import React from 'react'
import { Offset, Popup } from '@progress/kendo-react-popup';
import { Menu, MenuItem, MenuSelectEvent } from '@progress/kendo-react-layout';
import { Link } from 'react-router-dom';
import { MenuProps } from '../Contacts/ContactsMenu';
import { HeaderOptions } from '../HeaderOptions';

export const HeaderMenu = (props: MenuProps<HeaderOptions>) => {
    //const { data: contact } = UserApi.useGetUserByIdQuery(props?.contactId, { skip: !props?.contactId });
    const menuItemSelected = (e: MenuSelectEvent) => {
        //Fire the click event for this option
        props.options.find(o => o.id === e.item.data)?.onclick()

        props.itemClicked();
    }

    return (
        <Popup show={props?.visible}
            offset={props?.offset}
            anchorAlign={{ horizontal: 'right', vertical: 'bottom' }} className='contacts-menu' collision={{ horizontal: 'fit', vertical: 'fit' }}  >
            <Menu className='contacts-header-menu' vertical={true} style={{ display: "inline-block" }} onSelect={menuItemSelected} openOnClick={false} hoverCloseDelay={100}  >
                {props.options.map(o => (
                    <MenuItem render={() => {
                        return o.link
                            ? <Link target={'_blank'} to={o.link}>{o.element || <img src={o.image} className='tool-image' />} <span>{o.title}</span></Link>
                            : <div>{o.element || <img src={o.image} className='tool-image' />} <span>{o.title}</span></div>
                    }} icon={o.icon?.replace('k-i-', '')} text={o.title} data={o.id} />
                ))}
            </Menu>
        </Popup>

    )
}